import { styled } from '@mui/material/styles';

export const ScrollX = styled('div')({
  width: '100%',
  display: 'block',
  overflowX: 'auto',
});
